<template>
  <div class="spwwFooterPage">
    <div class="mainCont">
      <div class="footer">
        <span style="padding-right: 5px;">{{ $t('copyright') }}</span>
        <a style="margin-left: 10px;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ $t('forTheRecord') }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
  .spwwFooterPage {
    color: #999;
    text-align: center;
    padding: 5px 0;
    margin-top: 10px;
    border-top: 1px solid #e5e5e5;
    background-color: #f5f5f5;
    .mainCont {
      width: 1000px;
      margin: 0 auto;
      .footer {
        color: #9E9E9E;
        font-size: 12px;
        a {
          // color: #428BCA;
          color: #9E9E9E;
        }
      }
    }
  }
</style>
